// extracted by mini-css-extract-plugin
export default {"title":"AssignMultiTaskPopup_title__deOma","action":"AssignMultiTaskPopup_action__7GmEQ"};